module.exports = __webpack_public_path__ + "6567d6fc2679af736b8ea1944cf0ddc4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-pirate.png
// module id = 2889
// module chunks = 0